export default "__VITE_ASSET__dirlJx48__"